import { AutoMap } from '@automapper/classes';

export class PointagePauseEntity {
    Id?: number;
    @AutoMap()
    Debut!: string;
    @AutoMap()
    Fin!: string;
}
